import React from "react";
import clsx from "clsx";

const STATUS_COLORS = {
  pending: "bg-yellow-500",
  approved: "bg-green-700",
  rejected: "bg-red-700",
  open: "bg-emerald-300",
  active: "bg-blue-600",
  closed: "bg-blue-600",
};

export const BadgeValue = ({ value }) => {
  const normalized = value ? value.toLowerCase() : "";

  //   console.log("what is value to begin with", value);
  const color = STATUS_COLORS[normalized] || "bg-gray-600";

  const baseClasses =
    "absolute -top-6 -right-10 text-xs text-white truncate px-2 py-[3px] lg:py-1 my-1 max-w-min rounded-tr-lg rounded-bl-lg capitalize text-xs md:text-md";

  return <span className={clsx(baseClasses, color)}>{value}</span>;
};
